import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, NgZone, Output, Directive, NgModule } from '@angular/core';
import { typedFromEvent, tuiZoneOptimized } from '@taiga-ui/cdk/observables';
import { isNativeFocused } from '@taiga-ui/cdk/utils/focus';
import { merge } from 'rxjs';
import { map, startWith, distinctUntilChanged, skip } from 'rxjs/operators';

/**
 * Directive to monitor focus/blur status, works with focusIn/focus-out
 * instead of focus/blur to sync events order with Internet Explorer and
 * other focus related directives that require bubbling
 */
import * as ɵngcc0 from '@angular/core';
let TuiFocusedDirective = class TuiFocusedDirective {
    constructor({ nativeElement }, ngZone) {
        this.tuiFocusedChange = merge(typedFromEvent(nativeElement, 'focusin'), typedFromEvent(nativeElement, 'focusout')).pipe(map(() => isNativeFocused(nativeElement)), startWith(false), distinctUntilChanged(), skip(1), tuiZoneOptimized(ngZone));
    }
};
TuiFocusedDirective.ɵfac = function TuiFocusedDirective_Factory(t) { return new (t || TuiFocusedDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(NgZone)); };
TuiFocusedDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiFocusedDirective, selectors: [["", "tuiFocusedChange", ""]], outputs: { tuiFocusedChange: "tuiFocusedChange" } });
TuiFocusedDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] }
];
__decorate([
    Output()
], TuiFocusedDirective.prototype, "tuiFocusedChange", void 0);
TuiFocusedDirective = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(NgZone))
], TuiFocusedDirective);

let TuiFocusedModule = class TuiFocusedModule {
};
TuiFocusedModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiFocusedModule });
TuiFocusedModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiFocusedModule_Factory(t) { return new (t || TuiFocusedModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiFocusedDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiFocusedChange]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }]; }, { tuiFocusedChange: [{
            type: Output
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiFocusedModule, { declarations: [TuiFocusedDirective], exports: [TuiFocusedDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiFocusedModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiFocusedDirective],
                exports: [TuiFocusedDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFocusedDirective, TuiFocusedModule };

//# sourceMappingURL=taiga-ui-cdk-directives-focused.js.map